require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-x-mjw-p.json") })
        }
      }, "path---photos-professional-x-mjw-p");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-x-mjw-p!./.cache/json/photos-professional-x-mjw-p.json
// module id = 945
// module chunks = 231608221292675